// extracted by mini-css-extract-plugin
export default {"wrapper":"TableHeaderWrapper_wrapper__gKI24"};